import { RESET_UNIFIED_FORM } from "constants/ActionTypes";

export const resetTransactionForms = () => ({ type: RESET_UNIFIED_FORM });
